module.exports = __webpack_public_path__ + "img/SoftwareCopyright_4.fc5b5ee2.png";